export const NOT_AFFILIATED_PATH = "/not-affiliated";

/**
 * バックエンドの所属ゲート（MED-188）が返す 403 かどうかを判定する。
 * openapi-fetch はレスポンスボディ（{ detail, code }）を error として throw するため、
 * code === "NOT_AFFILIATED" で識別する。フロントはこのコードで所属確定フローへ誘導する。
 */
export const isNotAffiliatedApiError = (error: unknown): boolean => {
  return (
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    error.code === "NOT_AFFILIATED"
  );
};
